import { Page } from 'components/shared/Page/Page';
import { HeroImage } from 'components/shared/HeroImage';
import { navScrollTo, NavItem, useScrollerNav } from 'components/shared/ScrollerNav';
import { AboutCareers } from 'components/careers/AboutCareers';
import { Benefits } from 'components/careers/Benefits';
import { EmployeeQuotes } from 'components/careers/EmployeeQuotes';
import { JobPostings } from 'components/careers/JobPostings';
import { LearnMore } from 'components/careers/LearnMore';
import { CareersNavId, Department, Posting } from 'components/careers/types';
import Router from '@alltrails/shared/components/ReactRouter';
import { Context } from '@alltrails/shared/types/context';
import CAREERS_STRINGS from './careers.strings';

type CareersProps = {
  fullpath: string;
  context: Context;
  postings: Record<Department, Posting[]>;
};

const careerHeroJpg = require('../../../assets/images/careers/careers-hero.jpg');
const careerHeroAvif = require('../../../assets/images/careers/careers-hero.avif');
const careerHeroWebp = require('../../../assets/images/careers/careers-hero.webp');
const careerHeroMobileJpg = require('../../../assets/images/careers/careers-hero-750w.jpg');
const careerHeroMobileAvif = require('../../../assets/images/careers/careers-hero-750w.avif');
const careerHeroMobileWebp = require('../../../assets/images/careers/careers-hero-750w.webp');

const {
  CAREERS,
  CAREERS_AT_ALLTRAILS,
  HELP_KINDLE,
  CAREERS_HERO_ALT,
  NAV: { ABOUT_ALLTRAILS, OUR_BENEFITS, OPEN_POSITIONS, BROWSE_POSITIONS }
} = CAREERS_STRINGS;

const sections: NavItem[] = [
  { id: CareersNavId.AboutAllTrails, title: ABOUT_ALLTRAILS },
  { id: CareersNavId.OurBenefits, title: OUR_BENEFITS },
  { id: CareersNavId.OpenPositions, title: OPEN_POSITIONS }
];

const Careers = ({ context, fullpath, postings }: CareersProps) => {
  const { renderNavBar, renderSection } = useScrollerNav(CAREERS, sections, {
    onClick: () => navScrollTo(CareersNavId.OpenPositions),
    testId: 'browse-positions',
    text: BROWSE_POSITIONS
  });

  return (
    <div className="xlate-none">
      <Page context={context}>
        <Router fullpath={fullpath}>
          <HeroImage
            backgroundImage={{
              jpg: { src: careerHeroJpg, mobileSrc: careerHeroMobileJpg },
              avif: { src: careerHeroAvif, mobileSrc: careerHeroMobileAvif },
              webp: { src: careerHeroWebp, mobileSrc: careerHeroMobileWebp },
              alt: CAREERS_HERO_ALT
            }}
            headerText={CAREERS_AT_ALLTRAILS}
            headerSubText={HELP_KINDLE}
            onArrowClick={() => navScrollTo(CareersNavId.AboutAllTrails)}
          />
          {renderNavBar()}
          {renderSection(CareersNavId.AboutAllTrails, <AboutCareers />)}
          {renderSection(CareersNavId.OurBenefits, <Benefits />)}
          <EmployeeQuotes />
          {renderSection(CareersNavId.OpenPositions, <JobPostings postings={postings} />)}
          <LearnMore />
        </Router>
      </Page>
    </div>
  );
};

export { Careers as default, CareersProps };
